import { render, staticRenderFns } from "./ModalButtonSuccess.vue?vue&type=template&id=650596a4&scoped=true&"
import script from "./ModalButtonSuccess.vue?vue&type=script&lang=ts&"
export * from "./ModalButtonSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ModalButtonSuccess.vue?vue&type=style&index=0&id=650596a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650596a4",
  null
  
)

export default component.exports